module.exports = __webpack_public_path__ + "img/bg_new.86f728ac.jpg";